import React, { ReactElement, ChangeEvent, PureComponent } from 'react';
import Button, { ButtonStyles } from '../common/Button';
import * as BatchJobSettingsStore from '../../store/BatchJobSettingsStore';
import { connect } from 'react-redux';
import { excludeSpecialCharacters, getCurrentEnvironment } from '../../helpers/textHelpers';
import InfoModal from '../common/InfoModal';
import { PromptModal } from '../common/PromptModal';
import PopUpModal from '../common/PopUpModal';
import Input, { InputSize } from '../common/Input';
import { Dropdown } from '../common/Dropdown';
import { GustoFlag } from '../../models/GustoFlagStatus';

const headers = ['Gusto Flag', 'IsEnabled']

export class GustoFlagStatus extends PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            gustoFlagsChanged: [],
            isDirty: false,
            changesSubmitted: false,
            showSubmitPromptModal: false,
            showNewFlagPromptModal: false,
            newFlagStatus: false,
            newFlagName: "",
            revertedChanges: false,
            cancelledChanges: false,
            formMessage: "",
            formMessageColor: "",
            userComments: '',
        };
    }

    componentDidMount() {
        this.props.getGustoFlagStatus();
    }

    componentDidUpdate() {
        const { gustoFlagsChanged } = this.state;
        const { gustoFlags } = this.props;

        if (gustoFlagsChanged.length == 0 && gustoFlags) {
            this.setState({
                changesSubmitted: false,
                gustoFlagsChanged: gustoFlags,
            })
        }
    }

    reset = () => {
        const { gustoFlags } = this.props;
        if (gustoFlags) {
            this.setState({
                gustoFlagsChanged: gustoFlags.sort(this.settingSorter),
                isDirty: false,
                changesSubmitted: false,
                revertedChanges: true,
                cancelledChanges: false,
                formMessageColor: "red",
                formMessage: "Changes have been removed and not applied.",
            })
        }
    }

    onChange = (gustoFlag: string, e: ChangeEvent<HTMLSelectElement>) => {
        const { gustoFlagsChanged } = this.state;
        const changedSetting = gustoFlagsChanged.filter((x: any) => x.flagName == gustoFlag)[0];
        const filteredSettings = gustoFlagsChanged.filter((x: any) => x.flagName != gustoFlag);

        const newSettings = [...filteredSettings, {
            ...changedSetting,
            flagStatus: excludeSpecialCharacters(e.target.value),
            isDirty: true
        }];


        newSettings.sort(this.settingSorter);

        newSettings.sort(this.settingSorter);

        this.setState({
            gustoFlagsChanged: newSettings,
            isDirty: true,
            changesSubmitted: false
        });
    }

    settingSorter(first: any, second: any) {
        if (first.id > second.id) {
            return 1;
        }
        return -1;
    }

    isDirtyStyleObject(state: any): React.CSSProperties | undefined {
        if (state.isDirty) {
            return {
                fontWeight: state.isDirty ? "bold" : "normal",
                fontSize: "16px"
            }
        }
    }

    submitChanges = () => {
        const { gustoFlagsChanged } = this.state;
        const { updateGustoFlagStatus } = this.props;

        const filteredGustoFlags = gustoFlagsChanged.filter((x: any) => x.isDirty);
        const cleanGustoFlags = gustoFlagsChanged.filter((x: any) => !x.isDirty);

        var updatedGustoFlags = filteredGustoFlags.map((x: any) => ({ ...x, isDirty: false }));
        const newGustoFlags = [...cleanGustoFlags, ...updatedGustoFlags];
        newGustoFlags.sort(this.settingSorter);

        updateGustoFlagStatus(filteredGustoFlags);

        this.setState({
            gustoFlagsChanged: newGustoFlags,
            isDirty: false,
            changesSubmitted: true,
            showSubmitPromptModal: false,
            showNewFlagPromptModal: false,
            newFlagStatus: false,
            newFlagName: "",
            revertedChanges: false,
            cancelledChanges: false,
            formMessageColor: "green",
            formMessage: "Changes have been committed and saved."
        });
    }

    onFlagNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            newFlagName: e.target.value
        })
    }

    displayError = () => {
        const { changesSubmitted, formMessage, revertedChanges } = this.state;
        const { error } = this.props;

        if (error && formMessage !== "Changes have not been committed due to a technical error." && !revertedChanges && !changesSubmitted) {
            this.setState({ formMessageColor: "red", formMessage: "Changes have not been committed due to a technical error." })
        }

        if (error && changesSubmitted) {
            return (
                <InfoModal
                    title='Technical Error'
                    infoText={error}
                    onClose={this.closeErrorModal}
                />
            )
        }
    }

    closeErrorModal = (): void => {
        const { gustoFlags } = this.props;
        if (gustoFlags) {
            this.setState({
                gustoFlagsChanged: gustoFlags.sort(this.settingSorter),
                isDirty: false,
                changesSubmitted: false
            })
        }
    }

    submitAddNewFlag = async () => {
        const { addNewGustoFlagStatus } = this.props;
        const { newFlagStatus, newFlagName, gustoFlagsChanged } = this.state;
        if (newFlagStatus !== "True" && newFlagStatus !== "False") {
            this.setState({
                formMessageColor: "red",
                formMessage: "Flag status must be either true or false."
            });
            return;
        }

        let newFlag: GustoFlag = {
            id: (gustoFlagsChanged.length + 1).toString(),
            flagName: newFlagName,
            flagStatus: newFlagStatus.toString().toLowerCase(),
            modifiedDate: new Date().toISOString(),
        };

        addNewGustoFlagStatus([newFlag]);

        this.setState({
            gustoFlagsChanged: [...gustoFlagsChanged, newFlag],
            isDirty: false,
            changesSubmitted: true,
            showSubmitPromptModal: false,
            showNewFlagPromptModal: false,
            newFlagStatus: false,
            newFlagName: "",
            revertedChanges: false,
            cancelledChanges: false,
            formMessageColor: "green",
            formMessage: "New flag has been added."
        });
    }

    addNewFlagBody(): ReactElement {
        const { newFlagName } = this.state;
        return (
            <>
                <div className="container">
                    <div className='row'>
                        <div id="policyInformationLeftColumn" className="col-lg-12">
                            <Input
                                id="newFlagName"
                                label="Flag Name"
                                value={newFlagName || ''}
                                name="FlagNameTextBox"
                                dataQmAllow={true}
                                onChange={this.onFlagNameChange}
                                size={InputSize.Large}
                            />
                            <Dropdown
                                data={["True", "False"]}
                                onChange={(e) => {
                                    this.setState({ newFlagStatus: (e.target.value as boolean) });
                                }
                                }
                            />
                        </div>
                    </div>
                </div>
            </>
        )
    }

    updateComments = (commentValue: string): void => {
        this.setState({ userComments: commentValue });
    }

    render(): ReactElement {
        const { error } = this.props;
        const { gustoFlagsChanged, isDirty, changesSubmitted, showSubmitPromptModal, showNewFlagPromptModal, cancelledChanges, revertedChanges, formMessageColor, formMessage } = this.state;
        return (
            <>
                <div className="container margin-top">
                    {this.displayError()}
                    {showSubmitPromptModal &&
                        <PromptModal
                            title='Update Gusto Flags'
                            infoText={'You are about to submit this change directly to ' + getCurrentEnvironment() + ', are you sure you wish to continue?'}
                            yes={this.submitChanges}
                            no={() => this.setState({
                                showSubmitPromptModal: false,
                                cancelledChanges: true,
                                revertedChanges: false,
                                submitted: false,
                                formMessageColor: "red",
                                formMessage: "Changes have not been saved."
                            })}
                        />
                    }
                    {showNewFlagPromptModal &&
                        <PopUpModal
                            title='Add New Flag'
                            buttonText='Submit'
                            bodyContent={this.addNewFlagBody()}
                            onClose={() => this.setState({ showNewFlagPromptModal: false })}
                            onSubmit={this.submitAddNewFlag}
                            componentDidMount={() => { }}
                        />
                    }
                    <table className="table table--non-sortable table--editable-non-sortable">
                        <thead>
                            <tr>
                                {headers.map(header => (
                                    <th key={header} style={{ textAlign: 'left' }}>{header}</th>
                                ))}
                                <th>
                                    <Button title="Reset" onClick={this.reset} btnStyle={ButtonStyles.BlueCenteredTableButton} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {gustoFlagsChanged && gustoFlagsChanged.map((gustoFlag: any) => (
                                <tr key={gustoFlag.flagName}>
                                    <td style={this.isDirtyStyleObject(gustoFlag)} data-title={gustoFlag.flagName}>{gustoFlag.flagName}</td>
                                    <td data-title='Enabled'>
                                        <select
                                            id={gustoFlag.flagName}
                                            value={gustoFlag.flagStatus}
                                            onChange={(e) => this.onChange(gustoFlag.flagName, e)}
                                        >
                                            <option value="true">True</option>
                                            <option value="false">False</option>
                                        </select>
                                    </td>
                                    <td></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {(revertedChanges || cancelledChanges || changesSubmitted || error) &&
                        <p className={formMessageColor}>{formMessage}</p>
                    }
                    {isDirty && !changesSubmitted &&
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button title="Submit Changes" onClick={() => this.setState({ showSubmitPromptModal: true })} btnStyle={ButtonStyles.RightBlueButton} />
                        </div>
                    }
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button title="Add new flag" onClick={() => this.setState({ showNewFlagPromptModal: true })} btnStyle={ButtonStyles.RightBlueButton} />
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: any) => ({
    batchJobs: state.bjss.batchJobs,
    gustoFlags: state.bjss.gustoFlags,
    error: state.bjss.error
})

export default connect(mapStateToProps, BatchJobSettingsStore.actionCreators)(GustoFlagStatus);